import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const hero = document.getElementById('clinical-hero') as HTMLElement | null
const slides = gsap.utils.toArray<HTMLElement>('#clinical-hero .slide')

let timerPauseIndex = 0
let isFoundPauseIndex = false

slides.forEach((slide, index) => {
	if (index !== 0) {
		gsap.set(slide, { autoAlpha: 0, zIndex: index })
	}

	if (slide.querySelector('.slide-content__text') && !isFoundPauseIndex) {
		timerPauseIndex = index
		isFoundPauseIndex = true
	}
})

let currentSlideIndex = 0

if (hero) {
	// ⏸ how much scroll is reserved for the pause
	// ~0.18–0.22 ≈ ~2 seconds of reading time
	const HOLD_RATIO = 0.1

	const getHeaderHeight = () => {
		return document.querySelector('header.header')?.scrollHeight || 0
	}

	gsap.timeline({
		scrollTrigger: {
			trigger: hero,
			start: () => `top ${getHeaderHeight()}px`,
			end: () => `+=${window.innerHeight * 6 * (1 + HOLD_RATIO)}`,
			pin: hero,
			scrub: 1,

			onUpdate: (self: ScrollTrigger) => {
				// raw scroll progress
				const rawProgress = self.progress

				// visual progress stops before the hold zone
				const maxVisualProgress = 1 - HOLD_RATIO
				const visualProgress = Math.min(
					rawProgress / maxVisualProgress,
					1
				)

				// Update counter based on visual progress
				// Reach MAX_TIME before the last slide starts
				const progressToReachMax = timerPauseIndex / slides.length
				const counterProgress = Math.min(
					visualProgress / progressToReachMax,
					1
				)

				// Animate border radius/width/height progressively with counterProgress
				// Only animate while counter is progressing (counterProgress <= 1)
				const slidesWrapper = document.querySelector(
					'#clinical-hero .slides-wrapper'
				) as HTMLElement | null
				if (slidesWrapper) {
					// Get current breakpoint
					const isDesktop = window.matchMedia(
						'(min-width: 1500px)'
					).matches
					const isLaptop =
						window.matchMedia('(min-width: 992px)').matches

					let targetWidth = 80 // percentage
					let targetHeight = 79.03 // percentage

					if (isDesktop) {
						targetWidth = 90
						targetHeight = 90
					} else if (isLaptop) {
						targetWidth = 96.68
						targetHeight = 79.03
					}

					// Clamp counterProgress to max of 1 for radius calculations
					// This ensures radius completes exactly when counter reaches max and stops there
					const radiusProgress = Math.min(counterProgress, 1)

					// Calculate current values based on radiusProgress
					// Start from 100% and animate to target as counter progresses
					const currentWidth =
						100 - (100 - targetWidth) * radiusProgress
					const currentHeight =
						100 - (100 - targetHeight) * radiusProgress
					const currentRadius = 50 * radiusProgress // 0% to 50%

					// Apply values directly (no animation, scrubbed by scroll)
					gsap.set(slidesWrapper, {
						width: `${currentWidth}%`,
						height: `${currentHeight}%`,
						borderRadius: `${currentRadius}%`,
					})
				}

				const nextIndex = Math.min(
					Math.floor(visualProgress * slides.length),
					slides.length - 1
				)

				if (nextIndex === currentSlideIndex) return

				const nextSlide = slides[nextIndex]
				const currentSlide = slides[currentSlideIndex]

				gsap.timeline()
					.to(nextSlide, {
						autoAlpha: 1,
						duration: 0.1,
						onComplete: () => {
							const hasSlideCopy =
								nextSlide.querySelector('.slide-content')
							if (hasSlideCopy) {
								gsap.set(hasSlideCopy, { autoAlpha: 1 })
							}
						},
					})
					.to(currentSlide, {
						autoAlpha: 0,
						duration: 0,
						onComplete: () => {
							const hasSlideCopy =
								currentSlide.querySelector('.slide-content')
							if (hasSlideCopy) {
								gsap.set(hasSlideCopy, { autoAlpha: 0 })
							}
						},
					})

				currentSlideIndex = nextIndex
			},
		},
	})
}
